import { AlignSelfType, PaddingType } from 'common/types/styleTypes'
import {
  justifyContentCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type BurgerWrapperProps = {
  justifyContent: AlignSelfType
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  opened: boolean
  forceVisible: boolean
}
const BurgerWrapperUi = styled.div<BurgerWrapperProps>`
${p => (p.opened || p.forceVisible ? 'display: flex;' : 'display: none;')}
  box-sizing: content-box;
  min-height: 22px;
  ${justifyContentCss}
  ${paddingsCss}

  ${p => p.theme.phone} {
    display: flex;
    ${mobilePaddingsCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      display: flex;
      ${mobilePaddingsCss}
    `}

`

export default BurgerWrapperUi
